import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getTreasuryOldValueConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_treasury_old_pol_stats', timeframe)) as IPOLStats[]
	const pools = [
		'BTC.BTC',
		'ETH.ETH',
		'ETH.USDC-0XA0B86991C6218B36C1D19D4A2E9EB0CE3606EB48',
		'ETH.WBTC-0X2260FAC5E5542A773AA44FBCFEDF7C193BC2C599',
		'ETH.USDT-0XDAC17F958D2EE523A2206206994597C13D831EC7',
		'DOGE.DOGE',
		'LTC.LTC',
		'BCH.BCH',
		'BSC.BNB',
		'BSC.USDC-0X8AC76A51CC950D9822D68B83FE1AD97B32CD580D',
		'ETH.USDP-0X8E870D67F660D95D5BE530380D0EC0BD388289E1',
		'ETH.LUSD-0X5F98805A4E8BE255A32880FDEC7F6728C6568BA0',
		'ETH.GUSD-0X056FD409E1D7A124BD7017459DFEA2F387B6D5CD'
	]
	const assetData: IPOLStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []

	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	const series1 = assetData[0].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})
	const series2 = assetData[0].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_RUNE }
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: IPOLStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.CURRENT_VALUE_RUNE }
			})
		)
	})
	config.push({
		data: series1,
		strokeWidth: 2,
		name: `Total Value $`,
		type: 'line',
		seriesGroup: '[usd]',
		color: `${color}`,
		unitSymbol: '$'
	})
	config.push({
		data: series2,
		strokeWidth: 2,
		name: `Total Value ᚱ`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${colors[0]}`,
		unitSymbol: 'ᚱ'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[rune]',
			color: colors[i + 1],
			unitSymbol: 'ᚱ'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TreasuryOldValue = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTreasuryOldValueConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Current Value of Old Treasury Deployments"
			chartDesc={`Current value of Old Treasury deployments stacked by recipient pool in RUNE.\n Tracking address: thor1vmafl8f3s6uuzwnxkqz0eza47v6ecn0t086r2p`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default TreasuryOldValue
